import {immerable} from 'immer';

export default class MapVectorComponentModel {
  [immerable] = true;

  update(
    obj,
  ) {
    Object.keys(obj).forEach((key) => {
      if (this[key] !== undefined) {
        this[key] = obj[key];
      }
    });
  }

  _zoom;
  get zoom() {
    return this._zoom;
  }
  set zoom(zoom) {
    this._zoom = zoom;
  }

  _center;
  get center() {
    return this._center;
  }
  set center(center) {
    this._center = center;
  }

  _maps = [];
  get maps() {
    return this._maps;
  }
  set maps(maps) {
    this._maps = maps;
  }

  _minimapMaps = [];
  get minimapMaps() {
    return this._minimapMaps;
  }
  set minimapMaps(minimapMaps) {
    this._minimapMaps = minimapMaps;
  }

  _overMaps = [];
  get overMaps() {
    return this._overMaps;
  }
  set overMaps(overMaps) {
    this._overMaps = overMaps;
  }

  _layersGroup = [];
  get layersGroup() {
    return this._layersGroup;
  }
  set layersGroup(layersGroup) {
    this._layersGroup = layersGroup;
  }

  _positionMouse = [];
  get positionMouse() {
    return this._positionMouse;
  }
  set positionMouse(positionMouse) {
    this._positionMouse = positionMouse;
  }

  constructor(data) {
    const {
      zoom = 5,
      center = [0, 0],
      maps = [],
      minimapMaps = [],
      layersGroup = [],
      positionMouse = [0, 0],
    } = data;
    this.zoom = zoom;
    this.center = center;
    this.maps = maps;
    this.minimapMaps = minimapMaps;
    this.layersGroup = layersGroup;
    this.positionMouse = positionMouse;
  }
}
